import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from "@angular/core";

export type Variant = "primary" | "white" | "prune";

@Component({
  selector: "pax-spinner",
  standalone: true,
  imports: [CommonModule],
  template: `<div class="flex items-center justify-center">
    <div
      [ngClass]="{
        'inline-block h-6 w-6 animate-spin rounded-full border-2 border-solid border-primary-green border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]': true,
        'border-primary-green': variant === 'primary',
        'border-white': variant === 'white',
        'border-prune': variant === 'prune',
      }"
      role="status"
    >
      <span class="sr-only" i18n>Ladevorgang...</span>
    </div>
  </div>`,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Spinner {
  @Input() variant: Variant = "primary";
}
